import { VerbConjugation } from "src/data/models/VerbConjugationModel";

export const chunkArray = (arr: VerbConjugation[], size: number): VerbConjugation[][] => {
    const result: VerbConjugation[][] = [];
    for (let i = 0; i < arr.length; i += size) {
      result.push(arr.slice(i, i + size));
    }
    return result;
  };


